import React, { useState } from "react";
import MapDataPreview from "../MapDataPreview";
import { Link } from "react-router-dom";

export default function AboutSection() {
  // const [center, setCenter] = useState([110, 1.93]);
  // const [center, setCenter] = useState([90, 7]);
  // const [zoom, setZoom] = useState(4);
  const [center] = useState([105, 15]);
  const [zoom] = useState(3.5);
  const [basemap] = useState("gray");

  return (
    <div className="container mx-auto px-6">
      <div className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900 mb-8">
                About UNGEGN ASE Division
              </h2>

              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                UNGEGN ASE Division is a part of United Nations Group of Experts
                on Geographical Names (UNGEGN). The division consists of 12
                countries, which are Bhutan, Brunei, Cambodia, Indonesia, Laos,
                Malaysia, Myanmar, Philippines, Singapore, Sri Lanka, Thailand,
                Vietnam
              </p>

              <div className="mt-4">
                <Link
                  to="/aboutased"
                  className="inline-block px-4 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                >
                  Learn More
                </Link>
              </div>
            </div>

            {/* Map */}
            <div className="relative rounded-2xl shadow-2xl overflow-hidden">
              <MapDataPreview
                id="mapContainer"
                center={center}
                zoom={zoom}
                basemap={basemap}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
